import React, { useEffect, useRef } from "react";
import { SidepanelType, mondayOrgChartNodeDataForSidePanel, sidePanelType } from "state-atoms";
import style from "./mindmap-org-chart-side-panel.module.css";
import { useAtom } from "jotai";
import { OrgChartColumns } from "./mindmap-org-chart-mapper";

export default function CanvasMindmapOrgChartSidePanel() {
  const [node, setNodeData] = useAtom(mondayOrgChartNodeDataForSidePanel);
  const sidePanelRef = useRef(null);
  const [currentOpenedSidePanel, setOpenedSidePanel] = useAtom(sidePanelType);

  useEffect(() => {
    return () => {
      if (currentOpenedSidePanel === SidepanelType.mondayOrgChartNodeInfo) {
        setOpenedSidePanel(SidepanelType.none);
        setNodeData(null);
      }
    };
  }, []);

  const closeSidePanel = () => {
    setOpenedSidePanel(SidepanelType.none);
  };

  function renderCloseIcon() {
    return (
      <svg
        className={style.closeIcon}
        onClick={closeSidePanel}
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.36407 6.36396L19.092 19.0919M19.092 6.36396L6.36407 19.0919"
          stroke="#848199"
          strokeWidth="1.74"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  function renderContent() {
    if (!node) return null;
    const { node: item, configuration } = node;
    const baseMapping = configuration.columnMapping;
    const { columns } = item as any;
    const dataExtractor = new OrgChartColumns(configuration, columns);

    const columnsRendered = columns.map(({ id, title, type }: { id: string; title: string; type: string }) => {
      if (id == baseMapping.selfId || id == baseMapping.parentId || id == baseMapping.jobTitle) {
        return null;
      }
      if (type == "subtasks") {
        return null;
      }

      const valueToRender = dataExtractor.get(item, id);
      return (
        <div key={id} className={style.row}>
          <span className={style.columnTitle}>{title} :</span>
          <span className={style.columnValue} data-isavailable={true}>
            {valueToRender}
          </span>
        </div>
      );
    });

    return (
      <div>
        <div className={style.nameTitleRow}>
          <span className={style.nameTitle}>{item?.text}</span>
          {renderCloseIcon()}
        </div>
        <div className={style.row}>
          <span className={style.columnTitle}>Name :</span>
          <span className={style.columnValue}>{dataExtractor.getName(item)}</span>
        </div>

        <div className={style.row}>
          <span className={style.columnTitle}>Role :</span>
          <span className={style.columnValue}>{dataExtractor.getJobTitle(item)}</span>
        </div>

        <div className={style.row}>
          <span className={style.columnTitle}>Direct Manager :</span>
          <span className={style.columnValue}>{dataExtractor.getParent(item)}</span>
        </div>

        <div>{columnsRendered}</div>
      </div>
    );
  }

  return (
    <div
      ref={sidePanelRef}
      className={style.container}
      style={{
        paddingTop: document.getElementById("app-header-container")?.clientHeight || 100,
      }}
    >
      {renderContent()}
    </div>
  );
}
